// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BranchList-module__branchList__Mb_1x {
  min-width: calc(50% - 18px);
  margin-top: 2rem;
}

.BranchList-module__title__pbrdk {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
}

.BranchList-module__list__JpePS {
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
  gap: 1.5rem;
}

.BranchList-module__loading__cXFWS,
.BranchList-module__error__Jsdk7,
.BranchList-module__empty__GQ8RD {
  padding: 2rem;
  text-align: center;
  font-size: 1rem;
  color: #666;
}

.BranchList-module__error__Jsdk7 {
  color: #d32f2f;
  background: #ffebee;
  border-radius: 4px;
}

.BranchList-module__empty__GQ8RD {
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/components/BranchList/BranchList.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".branchList {\n  min-width: calc(50% - 18px);\n  margin-top: 2rem;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: #333;\n}\n\n.list {\n  display: grid;\n  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */\n  gap: 1.5rem;\n}\n\n.loading,\n.error,\n.empty {\n  padding: 2rem;\n  text-align: center;\n  font-size: 1rem;\n  color: #666;\n}\n\n.error {\n  color: #d32f2f;\n  background: #ffebee;\n  border-radius: 4px;\n}\n\n.empty {\n  color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"branchList": `BranchList-module__branchList__Mb_1x`,
	"title": `BranchList-module__title__pbrdk`,
	"list": `BranchList-module__list__JpePS`,
	"loading": `BranchList-module__loading__cXFWS`,
	"error": `BranchList-module__error__Jsdk7`,
	"empty": `BranchList-module__empty__GQ8RD`
};
export default ___CSS_LOADER_EXPORT___;
